import "./Packages.css";
import { motion } from "framer-motion";
import {
  FiCamera,
  FiEye,
  FiMic,
  FiMessageCircle,
  FiSmile,
  FiMoon,
  FiRefreshCw,
  FiSun,
  FiThermometer,
  FiRadio,
  FiWifi,
  FiClock,
} from "react-icons/fi";

const packages = [
  {
    key: "mini",
    tone: "mini",
    name: "Mini",
    eyebrow: "Başlangıç kapsamı",
    price: "10.990",
    description: "Bebeğini temel olarak takip etmek isteyen aileler için.",
    highlight: "Başlangıç",
    fit: "Görüntü, ses, gece görüşü ve oda sıcaklığı takibi sizin için yeterliyse.",
    features: [
      { icon: <FiCamera />, label: "1080p canlı görüntü" },
      { icon: <FiEye />, label: "Standart gece görüşü" },
      { icon: <FiMic />, label: "Ağlama algılama" },
      { icon: <FiSmile />, label: "Yüz görünürlüğü takibi" },
      { icon: <FiThermometer />, label: "Sıcaklık/nem takibi" },
      { icon: <FiClock />, label: "24 saat olay geçmişi" },
    ],
  },
  {
    key: "plus",
    tone: "plus",
    name: "Plus",
    eyebrow: "Mini'ye ek olarak",
    price: "17.990",
    description: "Uyku ve ağlama takibini daha ayrıntılı görmek isteyenler için.",
    highlight: "Önerilen",
    featured: true,
    fit: "Bebeğinizin uyku pozisyonu, dönme hareketi ve uyanıklık bilgileri de önemliyse.",
    features: [
      { icon: <FiCamera />, label: "2K canlı görüntü" },
      { icon: <FiEye />, label: "Geliştirilmiş gece görüşü" },
      { icon: <FiMessageCircle />, label: "Olası ağlama nedeni" },
      { icon: <FiMoon />, label: "Uyku pozisyonu" },
      { icon: <FiRefreshCw />, label: "Rollover takibi" },
      { icon: <FiSun />, label: "Uyku/uyanıklık takibi" },
      { icon: <FiClock />, label: "7-30 gün olay geçmişi" },
    ],
  },
  {
    key: "pro",
    tone: "pro",
    name: "Pro Mobile",
    eyebrow: "Plus'a ek olarak",
    price: "39.990",
    description: "Daha güçlü takip ve mobil kullanım isteyenler için.",
    highlight: "En kapsamlı",
    fit: "Ev dışında bağlantı, radar takibi ve daha gelişmiş ağlama yorumu istiyorsanız.",
    features: [
      { icon: <FiCamera />, label: "2K / 8 MP sensör" },
      { icon: <FiEye />, label: "Ayarlanabilir IR" },
      { icon: <FiMic />, label: "Yerel ve sunucu destekli ağlama algılama" },
      { icon: <FiMessageCircle />, label: "Olası neden + yerel temel model" },
      { icon: <FiRadio />, label: "60 GHz radar ile mikro-hareket" },
      { icon: <FiWifi />, label: "Harici Connect Box ile 4G/eSIM" },
      { icon: <FiClock />, label: "30 gün + yerel yedek" },
    ],
  },
];

function Packages() {
  return (
    <section className="packages" id="packages">
      <div className="container">
        <motion.div
          className="packages-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span>PAKET SEÇENEKLERİ</span>
          <h2 className="section-title">
            İhtiyacınıza göre
            <br />
            üç farklı Bybebek paketi.
          </h2>
        </motion.div>

        <div className="packages-grid">
          {packages.map((pack, index) => (
            <motion.article
              className={`package-card ${pack.tone} ${pack.featured ? "featured" : ""}`}
              key={pack.key}
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.08, duration: 0.45 }}
              viewport={{ once: true }}
            >
              <div className="package-head">
                <div className="package-meta-row">
                  <span className="package-eyebrow">{pack.eyebrow}</span>
                  <span className="package-pill">{pack.highlight}</span>
                </div>

                <h3>{pack.name}</h3>
                <p>{pack.description}</p>
              </div>

              <div className="package-fit">
                <strong>Kime uygun?</strong>
                <span>{pack.fit}</span>
              </div>

              <div className="package-features">
                {pack.features.map((feature) => (
                  <div className="package-feature" key={`${pack.key}-${feature.label}`}>
                    <span className="feature-icon">{feature.icon}</span>
                    <span>{feature.label}</span>
                  </div>
                ))}
              </div>

              <div className="package-price" aria-label={`${pack.name} fiyatı`}>
                <span>₺</span>
                <strong>{pack.price}</strong>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Packages;
